import clsx from 'clsx'
import React, { CSSProperties, FC } from 'react'

import { useTranslation } from '@Globals/Translations'

import styles from './Price.module.scss'

export interface PriceProps {
  className?: string
  discountPrice?: string
  firstPriceWeighted?: boolean
  isDiscountPriceFree?: boolean
  isPriceFree?: boolean
  price?: string
  showPlus?: boolean
  style?: CSSProperties
  theme?: 'white' | 'black' | 'black_red'
}

export const Price: FC<PriceProps> = ({ className,
  discountPrice,
  firstPriceWeighted = true,
  isDiscountPriceFree,
  isPriceFree,
  price,
  showPlus,
  style,
  theme = 'black_red' }) => {
  const { t } = useTranslation()
  return (
    <div className={clsx(className, styles.priceWrapper, styles[theme], firstPriceWeighted && styles.firstPriceWeighted)} style={style}>
      {showPlus && <p className={styles.additionalPrice}>{'+ '}</p>}
      {discountPrice && !isPriceFree && (
        <p className={clsx(
          styles.discount,
          'discountPrice',
          isDiscountPriceFree && styles.freeDiscount,
        )}
        >
          {`${isDiscountPriceFree ? t('common:FREE_LABEL') : discountPrice}`}
        </p>
      )}
      <p className={clsx(
        styles.price,
        'price',
        !isPriceFree && discountPrice && styles.discounted,
        !isPriceFree && discountPrice && 'discountedPrice',
        isPriceFree && styles.freePrice,
      )}
      >
        {`${isPriceFree ? t('common:FREE_LABEL') : (price || '')}`}
      </p>
    </div>
  )
}

